import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const PageHero = ({ index, title, subtitle, image }) => (
  <section className="relative pt-[74px] border-b border-[#DCE1E8] overflow-hidden bg-[#F4F6F9]">
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover opacity-15 grayscale" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#F4F6F9] via-[#F4F6F9]/85 to-[#F4F6F9]/60" />
      </div>
    )}
    <div className="relative max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-36">
      <div className="overline mb-6">{index}</div>
      <h1 className="font-display font-extrabold uppercase tracking-tighter text-5xl md:text-7xl lg:text-[5.5rem] leading-[0.88] max-w-5xl text-[#0E1626]">
        {title}
      </h1>
      {subtitle && <p className="mt-8 text-lg md:text-xl text-slate-600 font-light max-w-2xl">{subtitle}</p>}
    </div>
  </section>
);

export const SectionHeading = ({ index, title, className = "" }) => (
  <Reveal className={className}>
    <div className="overline mb-4">{index}</div>
    <h2 className="font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl leading-[0.95] max-w-3xl text-[#0E1626]">
      {title}
    </h2>
  </Reveal>
);

export const CTASection = () => (
  <section className="border-t border-[#1E293B] bg-[#0E1626] relative z-10 text-white" data-testid="cta-section">
    <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-32 grid lg:grid-cols-12 gap-10 items-end">
      <div className="lg:col-span-8">
        <div className="overline mb-5 !text-[#60A5FA]">Let's Build Together</div>
        <h2 className="font-display font-extrabold uppercase tracking-tighter text-4xl md:text-6xl leading-[0.9]">
          Have a Manufacturing Requirement?
        </h2>
        <p className="mt-8 text-lg md:text-xl text-slate-400 font-light max-w-2xl">
          If your company outsources pattern making, tooling, CNC machining or manufacturing requirements, we would like the opportunity to understand your requirement and provide a quotation.
        </p>
      </div>
      <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-4">
        <Link to="/enquiry" data-testid="cta-request-quote" className="btn-primary justify-center !bg-white !text-[#0E1626] hover:!bg-[#1D4ED8] hover:!text-white">Request A Quote <ArrowUpRight size={16} /></Link>
        <Link to="/reach-us" data-testid="cta-contact-us" className="btn-outline justify-center !border-[#334155] !text-slate-200 hover:!border-white hover:!text-white">Contact Us</Link>
      </div>
    </div>
  </section>
);
